import React, { Component } from "react";
import { Slider } from "antd";
import Utils from "@/utils";
import moment from "moment";
import sentGAEvent from "@/ga";
import { ReactComponent as PlayIcon } from "@/assets/icons/play.svg";
import { ReactComponent as PauseIcon } from "@/assets/icons/pause.svg";
import AudioWorkWaveformItemFunction from "./children/audioWorkContentWaveformItemFunction/AudioWorkWaveformItemFunction";
import AudioWorkContentFooterFunction from "./children/audioWorkContentFooterFunction/AudioWorkContentFooterFunction";
import TipsModalSimple from "@/components/common/tipSimpleModal/TipSimpleModal";
import "@/assets/audioAddMusic.less";

class AudioWorkContentFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: true,
      duration: "00:00.00",
      currentTime: "00:00.00",
      playing: false,
      start: "00:00.00",
      end: "00:00.00",
      selectedIndex: 0,
      mergeDuration: 0,
      trackCurrentTimePercent: 0,
      trackStartTimePercent: 0,
      trackEndTimePercent: 100,
      sliderCurrentTimePercent: 0,
    };
  }

  handleSliderTips = value => {
    const d = Utils.getSeconds(this.state.duration);
    return moment("00:00:00", "mm:ss:SS")
      .add((d * value) / 100, "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
  };

  play = () => {
    this.setState({
      playing: true,
    });
    const audioAddMusicList = [...this.props.audioAddMusicList];
    console.log(this.state.trackCurrentTimePercent, this.state.trackStartTimePercent, this.state.trackEndTimePercent);
    if (
      this.state.trackCurrentTimePercent > this.state.trackStartTimePercent &&
      this.state.trackCurrentTimePercent < this.state.trackEndTimePercent - 1
    ) {
      audioAddMusicList
        .filter(item => item.isLarge)
        .forEach(item => {
          item.wavesurfer.play();
        });
    } else {
      this.handleTrackTimePercentChange(this.state.trackStartTimePercent);
      audioAddMusicList
        .filter(item => item.isLarge)
        .forEach(item => {
          item.wavesurfer.play();
        });
    }
  };

  pause = () => {
    // this.handlePauseAllAudio();
    this.setState({
      playing: false,
    });
    const audioAddMusicList = [...this.props.audioAddMusicList];
    audioAddMusicList.forEach(item => {
      item.wavesurfer.pause();
    });
  };

  tooglePlay = () => {
    if (this.state.playing) {
      this.pause();
    } else {
      this.play();
      sentGAEvent({
        category: "add_music_action",
        action: "add_music_play_click",
      });
    }
  };

  handleSliderCurrentTimeChange = value => {
    let trackCurrentTimePercent =
      (value / 100) * (this.state.trackEndTimePercent - this.state.trackStartTimePercent) + this.state.trackStartTimePercent;
    this.setState({
      sliderCurrentTimePercent: value,
      trackCurrentTimePercent,
    });
    let audioAddMusicLargeList = this.props.audioAddMusicList.filter(item => item.isLarge);
    let audioAddMusicSmallList = this.props.audioAddMusicList.filter(item => !item.isLarge);
    // let largeItemDuration = 0;
    let largeItemCurrentTime = 0;
    audioAddMusicLargeList.forEach(item => {
      largeItemCurrentTime = (trackCurrentTimePercent / 100) * item.wavesurfer.getDuration();
      item.wavesurfer.setCurrentTime(largeItemCurrentTime);
      // largeItemDuration = item.wavesurfer.getDuration();
    });
    audioAddMusicSmallList.forEach(item => {
      let itemCurrentTime = largeItemCurrentTime - item.dragXTime;
      itemCurrentTime = itemCurrentTime < 0 ? 0 : itemCurrentTime > item.wavesurfer.getDuration() ? item.wavesurfer.getDuration() : itemCurrentTime;
      item.wavesurfer.setCurrentTime(itemCurrentTime);
    });
  };

  handleChangeAudioJoinerList = audioAddMusicItem => {
    const audioAddMusicList = [...this.state.audioAddMusicList];
    audioAddMusicList.forEach(item => {
      if (item.guid === audioAddMusicItem.guid) {
        item = audioAddMusicItem;
      }
    });
    this.setState({
      audioAddMusicList,
    });
  };

  handleDeleteAudioJoinerItem = () => {
    sentGAEvent({
      category: "add_music_action",
      action: "add_music_track_delete",
    });
    const guid = this.state.deleteGuid;
    let i;
    let audioAddMusicList = [...this.props.audioAddMusicList];
    audioAddMusicList.forEach((item, index) => {
      if (item.guid === guid) {
        i = index;
      }
      if (i && index > i) {
        item.fadeIn = this.props.audioAddMusicList[index - 1].fadeIn;
        item.fadeOut = this.props.audioAddMusicList[index - 1].fadeOut;
      }
    });
    audioAddMusicList = audioAddMusicList.filter(item => {
      return item.guid !== guid;
    });
    this.props.onAudioAddMusicListChange(audioAddMusicList);
    this.setState({
      selectedIndex: 0,
      deleteModal: false,
    });
  };

  getBeforeAudiosDuration = index => {
    let duration = 0;
    for (let i = 0; i < this.props.audioAddMusicList.length; i++) {
      if (i < index) {
        duration = duration + Utils.getSeconds(this.props.audioAddMusicList[i].end) - Utils.getSeconds(this.props.audioAddMusicList[i].start);
      } else {
        break;
      }
    }
    return duration;
  };

  handleCurrentTimeFormItem = (index, precent) => {
    if (this.props.audioAddMusicList.length > 1 && index > 0) {
      this.setState({
        currentTimePercent: (this.getBeforeAudiosDuration(index) / this.state.mergeDuration) * 100 + precent,
      });
    } else {
      this.setState({
        currentTimePercent: precent,
      });
    }
  };

  handleMergeAudioDuration = () => {
    let mergeDuration = 0;
    this.props.audioAddMusicList.forEach(item => {
      mergeDuration = mergeDuration + (Utils.getSeconds(item.end) - Utils.getSeconds(item.start));
    });
    // if (this.props.audioAddMusicList.length > 1) {
    //   mergeDuration = mergeDuration - this.props.audioAddMusicList.filter(item => item.fadeOut).length * 3;
    // }
    this.setState({
      mergeDuration,
    });
  };

  handlePauseAllAudio = () => {
    this.setState({
      playing: false,
    });
    this.props.audioAddMusicList.forEach(item => {
      if (item.wavesurfer && item.wavesurfer.isPlaying()) {
        item.wavesurfer.pause();
      }
    });
  };

  handleTrackTimePercentChange = value => {
    const { audioAddMusicList } = this.props;
    if (value < this.state.trackStartTimePercent) {
      value = this.state.trackStartTimePercent;
    } else if (value > this.state.trackEndTimePercent) {
      value = this.state.trackEndTimePercent;
    }
    let sliderCurrentTimePercent =
      ((value - this.state.trackStartTimePercent) / (this.state.trackEndTimePercent - this.state.trackStartTimePercent)) * 100;
    this.setState({
      trackCurrentTimePercent: value,
      sliderCurrentTimePercent: sliderCurrentTimePercent < 0 ? 0 : sliderCurrentTimePercent > 100 ? 100 : sliderCurrentTimePercent,
    });
    let audioAddMusicLargeList = audioAddMusicList.filter(item => item.isLarge);
    let audioAddMusicSmallList = audioAddMusicList.filter(item => !item.isLarge);
    let largeItemDuration = 0;
    let largeItemCurrentTime = 0;
    audioAddMusicLargeList.forEach(item => {
      largeItemDuration = item.wavesurfer.getDuration();
      largeItemCurrentTime = (value / 100) * largeItemDuration;
      item.wavesurfer.setCurrentTime(largeItemCurrentTime);
    });
    audioAddMusicSmallList.forEach(item => {
      let currentTime = largeItemCurrentTime - item.dragXTime;
      if (currentTime < 0) {
        currentTime = 0;
      } else if (currentTime > item.wavesurfer.getDuration()) {
        currentTime = item.wavesurfer.getDuration();
      }
      item.wavesurfer.setCurrentTime(currentTime);
    });
  };

  getTrackCurrentTimePercent = percent => {
    const { trackEndTimePercent } = this.state;
    if (percent > trackEndTimePercent) {
      this.handlePauseAllAudio();
      return false;
    }
    let sliderCurrentTimePercent =
      ((percent - this.state.trackStartTimePercent) / (this.state.trackEndTimePercent - this.state.trackStartTimePercent)) * 100;
    this.setState({
      trackCurrentTimePercent: percent,
      sliderCurrentTimePercent: sliderCurrentTimePercent < 0 ? 0 : sliderCurrentTimePercent > 100 ? 100 : sliderCurrentTimePercent,
    });
  };

  getTrackEndTimePercent = (endTime, index) => {
    const { audioAddMusicList } = this.props;
    let endTimePercent;
    let otherEndTimePercent;
    if (audioAddMusicList.length === 2) {
      let otherIndex = index === 0 ? 1 : 0;
      let endTimeNumber;
      let otherEndTimeNumber;
      let largeDuration;
      if (audioAddMusicList[index].isLarge) {
        endTimeNumber = Utils.getSeconds(endTime);
        otherEndTimeNumber = Utils.getSeconds(audioAddMusicList[otherIndex].end) + audioAddMusicList[otherIndex].dragXTime;
        largeDuration = Utils.getSeconds(audioAddMusicList[index].duration);
      } else {
        endTimeNumber = Utils.getSeconds(endTime) + audioAddMusicList[index].dragXTime;
        otherEndTimeNumber = Utils.getSeconds(audioAddMusicList[otherIndex].end);
        largeDuration = Utils.getSeconds(audioAddMusicList[otherIndex].duration);
      }
      endTimePercent = (endTimeNumber / largeDuration) * 100;
      otherEndTimePercent = (otherEndTimeNumber / largeDuration) * 100;
      if (endTimePercent > otherEndTimePercent) {
        this.setState({
          trackEndTimePercent: endTimePercent,
        });
      } else {
        this.setState({
          trackEndTimePercent: otherEndTimePercent,
        });
      }
    } else if (audioAddMusicList.length === 1) {
      this.setState({
        trackEndTimePercent: (Utils.getSeconds(audioAddMusicList[0].end) / Utils.getSeconds(audioAddMusicList[0].duration)) * 100,
      });
    }
  };

  getTrackStartTimePercent = (startTime, index) => {
    const { audioAddMusicList } = this.props;
    let startTimePercent;
    let otherStartTimePercent;
    if (audioAddMusicList.length === 2) {
      let otherIndex = index === 0 ? 1 : 0;
      let startTimeNumber;
      let otherStartTimeNumber;
      let largeDuration;
      if (audioAddMusicList[index].isLarge) {
        startTimeNumber = Utils.getSeconds(startTime);
        otherStartTimeNumber = Utils.getSeconds(audioAddMusicList[otherIndex].start) + audioAddMusicList[otherIndex].dragXTime;
        largeDuration = Utils.getSeconds(audioAddMusicList[index].duration);
      } else {
        startTimeNumber = Utils.getSeconds(startTime) + audioAddMusicList[index].dragXTime;
        otherStartTimeNumber = Utils.getSeconds(audioAddMusicList[otherIndex].start);
        largeDuration = Utils.getSeconds(audioAddMusicList[otherIndex].duration);
      }
      startTimePercent = (startTimeNumber / largeDuration) * 100;
      otherStartTimePercent = (otherStartTimeNumber / largeDuration) * 100;
      if (startTimePercent < otherStartTimePercent) {
        this.setState({
          trackStartTimePercent: startTimePercent,
        });
      } else {
        this.setState({
          trackStartTimePercent: otherStartTimePercent,
        });
      }
    } else if (audioAddMusicList.length === 1) {
      this.setState({
        trackStartTimePercent: (Utils.getSeconds(audioAddMusicList[0].start) / Utils.getSeconds(audioAddMusicList[0].duration)) * 100,
      });
    }
  };

  componentDidMount() {
    sentGAEvent({
      category: "add_music_page",
      action: "add_music_functionpage_display",
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.audioAddMusicList.length !== this.props.audioAddMusicList.length) {
      if (this.props.audioAddMusicList.length === 1) {
        this.getTrackStartTimePercent(this.props.audioAddMusicList[0].start, 0);
        this.getTrackEndTimePercent(this.props.audioAddMusicList[0].end, 0);
        this.props.audioAddMusicList[0].wavesurfer.setCurrentTime(Utils.getSeconds(this.props.audioAddMusicList[0].start));
      } else if (this.props.audioAddMusicList.length === 2) {
        this.getTrackStartTimePercent(this.props.audioAddMusicList[1].start, 1);
        this.getTrackEndTimePercent(this.props.audioAddMusicList[1].end, 1);
      }
    }
  }

  render() {
    return (
      <div className="workplace-content">
        <div className="audio-joiner-list">
          <div className={`frame ${this.props.audioAddMusicList.length < 2 ? "simple" : ""}`}>
            <Slider step={0.1} value={this.state.trackCurrentTimePercent} tipFormatter={null} onChange={this.handleTrackTimePercentChange} />
          </div>
          {this.props.audioAddMusicList.map((item, index) => (
            <AudioWorkWaveformItemFunction
              index={index}
              key={item.guid}
              audioAddMusicItem={item}
              mergeDuration={this.state.mergeDuration}
              audioAddMusicList={this.props.audioAddMusicList}
              trackCurrentTimePercent={this.state.trackCurrentTimePercent}
              handleAudioItemChange={this.props.handleAudioItemChange}
              handleDeleteAudioJoinerItem={guid => {
                this.handlePauseAllAudio();
                this.setState({
                  deleteGuid: guid,
                  deleteModal: true,
                });
              }}
              handleCurrentTimeFormItem={this.handleCurrentTimeFormItem}
              getTrackCurrentTimePercent={this.getTrackCurrentTimePercent}
              handlePauseAllAudio={this.handlePauseAllAudio}
              playing={this.state.playing}
              getTrackEndTimePercent={this.getTrackEndTimePercent}
              getTrackStartTimePercent={this.getTrackStartTimePercent}
            />
          ))}
        </div>
        {this.props.audioAddMusicList.length < 2 ? (
          <AudioWorkContentFooterFunction
            accept={this.props.accept}
            audioAddMusicList={this.props.audioAddMusicList}
            onAudioAddMusicListChange={this.props.onAudioAddMusicListChange}
            handlePauseAllAudio={this.handlePauseAllAudio}
            handleWarningObj={this.props.handleWarningObj}
            handlePurchaseModalObjChange={this.props.handlePurchaseModalObjChange}
          />
        ) : null}
        <div className="track">
          {this.state.playing ? (
            <PauseIcon className="icon" onClick={this.tooglePlay} style={{ marginRight: 10 }} />
          ) : (
            <PlayIcon className="icon" onClick={this.tooglePlay} style={{ marginRight: 10 }} />
          )}
          <div className="active" style={{ width: "100%" }}>
            <Slider step={0.01} value={this.state.sliderCurrentTimePercent} tipFormatter={null} onChange={this.handleSliderCurrentTimeChange} />
          </div>
        </div>
        <TipsModalSimple
          visible={this.state.deleteModal}
          onCancel={() => {
            this.setState({
              deleteModal: false,
            });
          }}
          content="Are you sure you want to delete it?"
          cancelBtnHandle={() => {
            this.setState({
              deleteModal: false,
            });
          }}
          confirmBtnHandle={this.handleDeleteAudioJoinerItem}
          confirmBtnText="YES"
        />
      </div>
    );
  }
}

export default AudioWorkContentFunction;
